export default {
    ADD_NOTIF_NEW(state, item) {
        state.notifList.push(item);
    },

    CHANGE_INITIATE(state, payload) {
        state.initiateAwal = payload;
    }
}
